import { render } from "./ImportUnmanagedInstance.vue?vue&type=template&id=50e51bea"
import script from "./ImportUnmanagedInstance.vue?vue&type=script&lang=js"
export * from "./ImportUnmanagedInstance.vue?vue&type=script&lang=js"

import "./ImportUnmanagedInstance.vue?vue&type=style&index=0&id=50e51bea&lang=less"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__